/*
  Pick: barrel count, video poster and the section analytics events.

  Moved out of sections/brewzle-pick.liquid on 2026-09-21. It was inline, so it ran during
  parse and held up first paint: Lighthouse put 1,841ms of main thread on the
  document itself, and the hero photo, already downloaded by ~480ms, was waiting
  on it. Loaded with defer instead, which runs after the document is parsed.

  The code is unchanged apart from the root lookup. It used to interpolate the
  section id into a class selector; it now finds the same element by the
  data-bz-section attribute the section already carries.
*/
(function () {
    // Scoped per instance, the way the inline version was: it keyed on its own
    // section id, so a second copy of this section on a page got its own
    // behaviour. A bare querySelector would have bound only the first. One
    // instance per page on templates/page.brewzle.json today; this does not
    // rely on that staying true.
    var bzRoots = document.querySelectorAll('[data-bz-section="pick"]');
    for (var bzIndex = 0; bzIndex < bzRoots.length; bzIndex++) initBrewzlePick(bzRoots[bzIndex]);

    function initBrewzlePick(root) {

    var barrelCount = Number(window.__BREWZLE_BARREL_COUNT__);
    if (isFinite(barrelCount) && barrelCount > 0) {
      root.querySelectorAll('[data-bz-barrel-count]').forEach(function (el) {
        el.textContent = String(barrelCount);
      });
    }

    var videoUrl = root.getAttribute('data-bz-video-url') || '';
    var trigger = root.querySelector('[data-bz-video-trigger]');
    var frameHost = root.querySelector('[data-bz-video-frame]');
    if (!trigger || !frameHost || !videoUrl) return;

    function toEmbedUrl(raw) {
      var u;
      try {
        u = new URL(raw, window.location.href);
      } catch (e) {
        return null;
      }
      var host = u.hostname.replace(/^www\./, '');
      if (host === 'youtu.be') {
        var shortId = u.pathname.slice(1);
        return shortId ? 'https://www.youtube-nocookie.com/embed/' + shortId + '?autoplay=1&rel=0' : null;
      }
      if (host === 'youtube.com' || host === 'm.youtube.com') {
        if (u.pathname === '/watch') {
          var vid = u.searchParams.get('v');
          return vid ? 'https://www.youtube-nocookie.com/embed/' + vid + '?autoplay=1&rel=0' : null;
        }
        if (u.pathname.indexOf('/embed/') === 0) {
          return raw + (raw.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
        }
        if (u.pathname.indexOf('/shorts/') === 0) {
          var shortsId = u.pathname.split('/')[2];
          return shortsId ? 'https://www.youtube-nocookie.com/embed/' + shortsId + '?autoplay=1&rel=0' : null;
        }
        return null;
      }
      if (host === 'vimeo.com') {
        var parts = u.pathname.split('/').filter(Boolean);
        var vimeoId = parts[parts.length - 1];
        return vimeoId && /^\d+$/.test(vimeoId) ? 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1' : null;
      }
      if (host === 'player.vimeo.com') {
        return raw + (raw.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
      }
      return null;
    }

    trigger.addEventListener('click', function () {
      var embedUrl = toEmbedUrl(videoUrl);
      if (!embedUrl) {
        // Not a recognized YouTube/Vimeo URL: never guess at an iframe src, open it instead.
        window.open(videoUrl, '_blank', 'noopener');
        return;
      }
      var iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.title = root.getAttribute('data-bz-video-title') || '';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';
      frameHost.appendChild(iframe);
      frameHost.hidden = false;
      trigger.hidden = true;
      trigger.setAttribute('aria-hidden', 'true');
      trigger.tabIndex = -1;

      try {
        root.dispatchEvent(new CustomEvent('bz-pick:video-played', { bubbles: true, detail: { video_url: videoUrl } }));
      } catch (e) {
        /* CustomEvent unsupported: analytics only */
      }
    });
    }
  })();
